// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2eBTq","image-wrapper":"styles_image-wrapper__2blnw","content":"styles_content__2TGfS","icon":"styles_icon__1Jyyc","name":"styles_name__2nf5h"};